import { useState } from "react";
import "./startWindow.css"; // Import the separate CSS file

export default function StartWindow() {
    const [show, setShow] = useState(true);

    return (
        show && (
            <div className="start-window-overlay">
                <div className="start-window-modal">
                    <p className="text-lg font-semibold">Hello! This is a very early version of this application that I've made public. Features will be continuously added until the application exits alpha.</p>
                    <p className="text-lg font-semibold">
                        Visit my website {" "}
                        <a
                            href="https://www.clayc.cc"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            here 
                        </a>
                        &nbsp;for updates!
                    </p>          <button
                        className="start-window-button"
                        onClick={() => setShow(false)}
                    >
                        OK
                    </button>
                </div>
            </div>
        )
    );
}
